import { Edges, Text, Billboard, Line } from "@react-three/drei";

import { Obstacle } from "../../utils/apolloRenderer";

/**
 * S4 — 인식 장애물(z-up). 타입별 색상 3D 박스 + 진행방향선 + 속도 라벨(이동 중).
 * (Dreamview obstacles.js 참조. 폴 주기(150ms)로 스냅 — 보간은 S6에서.)
 */

// Apollo Object.Type: 3 PEDESTRIAN,4 BICYCLE,5 VEHICLE,6 VIRTUAL,7 CIPV
const OBSTACLE_COLOR: { [k: number]: string } = { 3: "#ff5a5a", 4: "#ffb302", 5: "#3aa0ff", 6: "#9aa0a6", 7: "#ff2d55" };
const col = (t?: number) => (t != null && OBSTACLE_COLOR[t]) || "#a07bff";
const TYPE_LABEL: { [k: number]: string } = { 0: "미상", 1: "이동체", 2: "고정체", 3: "보행자", 4: "자전거", 5: "차량", 6: "가상", 7: "CIPV" };

function ObstacleMesh({ o }: { o: Obstacle }) {
    const L = Math.max(0.4, o.length || 0.8);
    const W = Math.max(0.4, o.width || 0.8);
    const H = Math.max(0.6, o.height || 1.5);
    const color = col(o.type);
    const spKmh = (o.speed || 0) * 3.6;
    return (
        <group position={[o.x, o.y, 0]} rotation={[0, 0, o.heading || 0]}>
            <mesh position={[0, 0, H / 2]}>
                <boxGeometry args={[L, W, H]} />
                <meshStandardMaterial color={color} transparent opacity={0.32} depthWrite={false} />
                <Edges color={color} />
            </mesh>
            {/* 진행방향 */}
            <Line points={[[0, 0, H * 0.5], [L * 0.5 + 0.8, 0, H * 0.5]]} color={color} lineWidth={1.5} />
            {/* 속도 라벨(이동 중만) */}
            {spKmh > 1 && (
                <Billboard position={[0, 0, H + 0.9]}>
                    <Text fontSize={0.9} color="#e8eef5" anchorX="center" anchorY="middle" outlineWidth={0.06} outlineColor="#0a0f16">
                        {`${TYPE_LABEL[o.type ?? 0] ?? ""} ${spKmh.toFixed(0)}km/h`}
                    </Text>
                </Billboard>
            )}
        </group>
    );
}

export default function Obstacles({ list, visible = true }: { list: Obstacle[]; visible?: boolean }) {
    if (!visible) return null;
    return (
        <group>
            {(list || []).map((o, i) => <ObstacleMesh key={o.id || `obs${i}`} o={o} />)}
        </group>
    );
}
